import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

interface CADGridBackgroundProps {
  opacity?: number;
  showCoordinates?: boolean;
  className?: string;
}

const EDGE_MASK =
  "radial-gradient(ellipse 90% 80% at 50% 50%, transparent 22%, black 78%)";

const COORDS = [
  { label: "X:052.40 / Y:011.92", className: "left-[6%] top-[16%]" },
  { label: "GRID-07 // SECTOR-N", className: "right-[7%] top-[30%] hidden sm:block" },
  { label: "Δ 90.000°", className: "left-[9%] bottom-[24%] hidden sm:block" },
  { label: "ELEV +00.00", className: "right-[10%] bottom-[16%]" },
];

const CROSSHAIRS = [
  { className: "left-[20%] top-[38%] hidden md:block" },
  { className: "right-[22%] bottom-[38%] hidden md:block" },
];

export function CADGridBackground({
  opacity = 0.5,
  showCoordinates = true,
  className,
}: CADGridBackgroundProps) {
  return (
    <motion.div
      data-testid="cad-grid-background"
      aria-hidden
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1.4, ease: "easeOut" }}
      className={cn("pointer-events-none absolute inset-0 overflow-hidden", className)}
    >
      <div
        className="animate-cad-drift absolute inset-0"
        style={{
          backgroundImage:
            "linear-gradient(to right, rgba(71,85,105,0.13) 1px, transparent 1px), linear-gradient(to bottom, rgba(71,85,105,0.13) 1px, transparent 1px)",
          backgroundSize: "28px 28px",
          maskImage: EDGE_MASK,
          WebkitMaskImage: EDGE_MASK,
          opacity: opacity,
        }}
      />
      <div
        className="absolute inset-0"
        style={{
          backgroundImage:
            "linear-gradient(to right, rgba(71,85,105,0.28) 1px, transparent 1px), linear-gradient(to bottom, rgba(71,85,105,0.28) 1px, transparent 1px)",
          backgroundSize: "140px 140px",
          maskImage: EDGE_MASK,
          WebkitMaskImage: EDGE_MASK,
          opacity: opacity,
        }}
      />
      {showCoordinates &&
        COORDS.map((c) => (
          <span
            key={c.label}
            className={cn(
              "absolute font-mono text-[10px] uppercase tracking-[0.22em] text-cad/80",
              c.className,
            )}
            style={{ opacity }}
          >
            {c.label}
          </span>
        ))}
      {showCoordinates &&
        CROSSHAIRS.map((c, i) => (
          <span
            key={i}
            className={cn("absolute font-mono text-xs text-cad/60", c.className)}
            style={{ opacity }}
          >
            +
          </span>
        ))}
    </motion.div>
  );
}
